import { render, staticRenderFns } from "./BaseDialog.vue?vue&type=template&id=16f42b8e&scoped=true&"
import script from "./BaseDialog.vue?vue&type=script&lang=ts&"
export * from "./BaseDialog.vue?vue&type=script&lang=ts&"
import style0 from "./BaseDialog.vue?vue&type=style&index=0&id=16f42b8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f42b8e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VForm,VIcon,VRow})
